<section>
    <div class="side-nav" [attr.isCollapsed]="isCollapsed ? '1' : '0'">
        <app-side-nav-bar [isEmptySideBar]="true">
        </app-side-nav-bar>
    </div>
    <div class="container" [attr.isCollapsed]="isCollapsed ? '1' : '0'">
        <div class="header">
            <app-minimal-header></app-minimal-header>
        </div>
        <div class="content">
            <div class="content-wrapper" >
              <app-main-layout-page [isSideNavCollapsed]="isCollapsed">
                <app-router></app-router>
              </app-main-layout-page>
            </div>
        </div>
    </div>
</section>